/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Csjensblank_Arbeitstreffen_Begleiten34Inputs */

const en__field_enum_csjensblank_arbeitstreffen_begleiten34 = /** @type {(inputs: _Field_Enum_Csjensblank_Arbeitstreffen_Begleiten34Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fllow your mentor in one of his meetings`)
};

const de__field_enum_csjensblank_arbeitstreffen_begleiten34 = /** @type {(inputs: _Field_Enum_Csjensblank_Arbeitstreffen_Begleiten34Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mentor/ Mentorin zu Arbeitstreffen begleiten (Meetings, Messen, etc.)`)
};

/**
* | output |
* | --- |
* | "Fllow your mentor in one of his meetings" |
*
* @param {_Field_Enum_Csjensblank_Arbeitstreffen_Begleiten34Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_csjensblank_arbeitstreffen_begleiten34 = /** @type {((inputs?: _Field_Enum_Csjensblank_Arbeitstreffen_Begleiten34Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Csjensblank_Arbeitstreffen_Begleiten34Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_csjensblank_arbeitstreffen_begleiten34(inputs)
	return de__field_enum_csjensblank_arbeitstreffen_begleiten34(inputs)
});
export { _field_enum_csjensblank_arbeitstreffen_begleiten34 as "_field_enum_CSJENSBLANK_ARBEITSTREFFEN_BEGLEITEN" }